import { useState, useEffect } from 'react';
import { languageService } from '../services/language';

export const useTranslation = () => {
    const [language, setLanguage] = useState(languageService.getCurrentLanguage());

    useEffect(() => {
        const unsubscribe = languageService.subscribe((newLanguage) => {
            setLanguage(newLanguage);
        });

        return unsubscribe;
    }, []);

    const t = (key: string, fallback?: string) => {
        return languageService.translate(key, fallback);
    };

    const getLanguageInfo = (code?: string) => {
        return languageService.getLanguageInfo(code);
    };

    const isRTL = () => {
        return languageService.getLanguageInfo().dir === 'rtl';
    };

    return {
        language,
        t,
        getLanguageInfo,
        isRTL,
        setLanguage: (code: string) => languageService.setLanguage(code),
        resetToDefault: () => languageService.resetToDefault(),
        clearStoredLanguage: () => languageService.clearStoredLanguage(),
        forceRefresh: () => languageService.forceRefresh(),
        forceSetLanguage: (code: string) => languageService.forceSetLanguage(code)
    };
};

